export const hasErrorsInTab = (
  tabId: string,
  errors: Record<string, any>,
): boolean => {
  return Object.keys(errors).includes(tabId);
};

export const hasAnyFormErrors = (errors: Record<string, any>): boolean => {
  return Object.keys(errors).length >= 1;
};
